/* oxlint-disable @fullscript/gql-file-usage */
// REASON: pre-existing operation file, to be migrated to a .gql file in a follow up MR
import { gql } from "@apollo/client";

const MFA_Shared_Query = gql`
  query MFA_Shared_Query {
    currentUser {
      id
      hasMultipleStorePlatforms
      twoFactorAuthentication {
        id
        isEnabled
        isLocked
        otpMethod
        phoneLast4
        email
        emailMasked
      }
    }
  }
`;

export { MFA_Shared_Query };
